import { useWorkspaceKeysStore } from '@easy-expense/data-firestore-client';
import {
  DownloadExpenseRequest,
  DownloadReportRequest,
  Entity,
  EntityName,
} from '@easy-expense/data-schema-v2';
import { fuego } from '@easy-expense/firebase-app';

export function useCreateRequest<T extends Entity>(entityName: EntityName) {
  const currentWorkspacePath = useWorkspaceKeysStore((s) => s.currentWorkspacePath());
  if (!currentWorkspacePath) {
    return;
  }
  return async function createRequest(requestData: T) {
    const reqDoc = fuego.db().doc(`${currentWorkspacePath}/${entityName}s/${requestData.key}`);

    await reqDoc.set(requestData);
    return reqDoc;
  };
}
export function useCreateDownloadRequest() {
  return useCreateRequest<DownloadExpenseRequest>('downloadExpensesRequest');
}
export function useCreateDownloadReportRequest() {
  return useCreateRequest<DownloadReportRequest>('generateReportPDFRequest');
}

export function useCreateDownloadReportHTMLRequest() {
  return useCreateRequest<DownloadReportRequest>('generateReportHTMLRequest');
}
